import { axios } from "@/client/libs/axios";

export type JobFeedback = "applied" | "not_applied";

export type OpenJobLinkPayload = {
  studentId: string;
  studentName: string;
  studentEmail?: string;
  studentRollNo?: string;
  jobUniqueId: string;
  jobTitle: string;
  company: string;
  location?: string;
  source?: string;
  jobPostLink: string;
};

export type SaveJobFeedbackPayload = {
  studentId: string;
  jobUniqueId: string;
  feedback: JobFeedback;
};

export type InternshipJobApplicationRecord = {
  studentId: string;
  studentName: string;
  studentEmail?: string;
  studentRollNo?: string;
  jobUniqueId: string;
  jobTitle: string;
  company: string;
  location?: string;
  source?: string;
  jobPostLink: string;
  applicationOpenedAt?: string;
  feedback?: JobFeedback;
  feedbackUpdatedAt?: string;
  appliedAt?: string;
  createdAt: string;
  updatedAt: string;
};

type ApiResponse<T> = {
  message: string;
  statusCode: number;
  result: T;
};

export const openInternshipJobLink = async (payload: OpenJobLinkPayload) => {
  const response = await axios.post<ApiResponse<InternshipJobApplicationRecord>>(
    "/internship-jobs/open-link",
    payload,
  );
  return response.data.result;
};

export const saveInternshipJobFeedback = async (payload: SaveJobFeedbackPayload) => {
  const response = await axios.post<ApiResponse<InternshipJobApplicationRecord>>(
    "/internship-jobs/feedback",
    payload,
  );
  return response.data.result;
};

export const fetchStudentInternshipJobs = async (studentId: string) => {
  const response = await axios.get<ApiResponse<InternshipJobApplicationRecord[]>>(
    `/internship-jobs/student/${studentId}`,
  );
  return response.data.result;
};
